import type { PortalConfig, SectionId } from '@sonder/shared'
import { Link } from 'react-router'
import { enabledSections, useProgress } from '@/data/client'
import { StepPill } from './ReviewAnswers'

type Progress = ReturnType<typeof useProgress>

/**
 * The onboarding steps at a glance: number, title, done of total and where each stands. Each title either opens
 * the step (`to`) or does something on the page, like jumping to its answers (`onSelect`).
 */
export function StepSummary({ config, brandCount, progress, to, onSelect, label = 'Steps' }: { config: PortalConfig; brandCount?: number; progress: Progress; to?: (id: SectionId) => string; onSelect?: (id: SectionId) => void; label?: string }) {
  const titleClass = 'flex-1 text-left text-body text-ink underline-offset-4 hover:underline'
  return (
    <nav aria-label={label}>
      <ul className="grid divide-y divide-gray-200 border-y border-gray-200">
        {enabledSections(config, brandCount).map((s) => {
          const id = s.id as SectionId
          const p = progress?.sections[id]
          return (
            // On a phone the count and status go on a second line under the title, so the title keeps the full width.
            <li key={id} className="grid grid-cols-[2rem_minmax(0,1fr)] items-center gap-x-4 gap-y-1.5 py-4 sm:flex sm:flex-wrap sm:gap-4">
              <span className="w-8 font-display text-h5 text-dim">{s.number}</span>
              {to ? (
                <Link to={to(id)} className={titleClass}>{s.title}</Link>
              ) : (
                <button type="button" onClick={() => onSelect?.(id)} className={titleClass}>{s.title}</button>
              )}
              <span className="col-start-2 flex items-center gap-3 sm:contents">
                <span className="text-small text-dim tabular-nums">{p ? `${p.done}/${p.total}` : ''}</span>
                <StepPill state={progress?.states[id] ?? 'todo'} unconfirmed={p?.unconfirmed ?? 0} optional={s.optional} />
              </span>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
